import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import that from "../main";
import DonMessage from "../utils/message";
import { Loading } from "element-ui";
import store from '../store/store.js';

// 如果接口500ms内返回，不要遮罩层；否则添加遮罩层
// let loadingInstance = null; //蒙版实例
// let timer = null; //定时器

/**
 * 模拟一个出入栈
 */
let loadingInstance = null; // 记录页面中存在的loading
// let loadingCount = 0; // 记录当前正在请求的数量

function showLoading() {
    // console.log("showLoading: ", loadingCount);
    // if (loadingCount === 0) {
    loadingInstance = Loading.service({
        lock: true,
        text: "努力加载中！",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
    });
    // }
    // loadingCount++;
}

function hideLoading() {
    // console.log("hideLoading: ", loadingCount);
    if (loadingInstance !== null) {
        loadingInstance.close();
        loadingInstance = null;
    }

    // if (loadingInstance) {
    //     loadingCount--;
    //     loadingInstance.close();
    //     loadingInstance = null;
    // }
}

/**
 * @description: 业务 20 服务器
 */
const $http = axios.create({
    baseURL: process.env.VUE_APP_HTTP_URL, //正式环境
    timeout: 300000,
    responseType: "json",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Accept-Language': store.state.language.language||'zh-CN'
    }
});

// 请求qs序列化
$http.interceptors.request.use(
    config => {
        // // 添加遮罩层
        // if (timer !== null) {
        //     clearTimeout(timer);
        // }
        // timer = setTimeout(() => {
        //     //如果存在则关闭
        //     if (loadingInstance !== null) {
        //         loadingInstance.close();
        //     }
        //     loadingInstance = Loading.service({
        //         lock: true,
        //         text: "努力加载中！",
        //         spinner: "el-icon-loading",
        //         background: "rgba(0, 0, 0, 0.7)"
        //     });
        // }, 100);
        // if (!config.loadingHide) {
        //     showLoading();
        //     // console.log("config: ", config);
        // }

        const token = sessionStorage.getItem("token");
        if (
            config.method === "post" &&
            config.headers["Content-Type"] ===
                "application/x-www-form-urlencoded"
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: "indices",
                allowDots: true
            });
        }
        if (token) {
            config.headers.token = token;
        }
        return config;
    },
    error => {
        DonMessage({
            showClose: true,
            message: error && error.data.error_msg,
            type: "error"
        });
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res.bus_json
$http.interceptors.response.use(
    res => {
        //如果请求返回快的话，就不需要loading
        // 清除定时器
        // clearTimeout(timer);
        // timer = null;
        // // 请求返回后，关闭loading
        // if (loadingInstance !== null) {
        //     loadingInstance.close();
        // }
     //   hideLoading();
        if (res.data) {
            if (res.data.token && res.data.token.length) {
                sessionStorage.setItem("token", res.data.token);
            }
            switch (res.data.error_code) {
                case "-1":
                    DonMessage.warning({
                        showClose: true,
                        message: "请求超时，请重新登录"
                    });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                case "0":
                    return res.data;
                case "1":
                    if (
                        res.data.error_msg === "token is null" &&
                        res.data.error_msg != "账号密码错误！"
                    ) {
                        DonMessage.error({
                            showClose: true,
                            message: res.data.error_msg + "，请重新登录"
                        });
                        sessionStorage.clear();
                        setTimeout(() => {
                            that.$router.push({
                                path: "/login"
                            });
                        }, 1000);
                    }
                    if (res.data.error_msg !== "token is null") {
                        DonMessage.error({
                            showClose: true,
                            message: res.data.error_msg
                        });
                    }
                    if (!res.data.bus_json) {
                        return res.data;
                    }
                    break;
                case "2":
                    DonMessage.warning({
                        showClose: true,
                        message: res.data.error_msg
                    });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                default:
                    //其他默认返回的blob文件流
                    return res.data;
            }
        }
    },
    error => {
        //如果请求返回快的话，就不需要loading
        // 清除定时器
        // clearTimeout(timer);
        // timer = null;
        // // 请求返回后，关闭loading
        // if (loadingInstance !== null) {
        //     loadingInstance.close();
        // }
        hideLoading();
        console.log(error);
    }
);

export default $http;
